import React from 'react';
import { LayoutDashboard, PieChart, Wallet, Sparkles, LogOut, Settings, Flame, X, Landmark } from 'lucide-react';
import { ViewState } from '../types';

interface SidebarProps {
  currentView: ViewState;
  setView: (view: ViewState) => void;
  onLogout: () => void;
  isMobileOpen: boolean;
  onClose: () => void;
}

const Sidebar: React.FC<SidebarProps> = ({ currentView, setView, onLogout, isMobileOpen, onClose }) => {
  const menuItems = [
    { id: 'dashboard', label: 'Dashboard', icon: LayoutDashboard },
    { id: 'fire', label: 'FIRE Lab', icon: Flame },
    { id: 'holdings', label: 'Portfolio', icon: Wallet },
    { id: 'pensions', label: 'Pensions', icon: Landmark },
    { id: 'ai-lab', label: 'AI Analyst', icon: Sparkles },
    { id: 'analytics', label: 'Analytics', icon: PieChart },
  ];

  return (
    <div
      className={`w-64 bg-[#13131a] text-slate-300 ${isMobileOpen ? 'flex' : 'hidden'} md:flex flex-col h-full border-r border-white/5 transform transition-transform duration-200 fixed inset-y-0 left-0 z-50 md:static md:translate-x-0 ${
        isMobileOpen ? 'translate-x-0 shadow-2xl shadow-black/40' : '-translate-x-full'
      }`}
    >
      <div className="p-6 flex items-center justify-between">
        <div className="flex items-center space-x-3">
          <img
            src="/logo.jpg?v=2"
            alt="FIRErify logo"
            className="h-10 w-10 rounded-xl object-cover shadow-sm"
          />
          <span className="text-xl font-bold text-white tracking-tight">FIRErify</span>
        </div>
        <button
          className="md:hidden p-2 text-slate-400 hover:text-white rounded-lg hover:bg-white/5"
          aria-label="Close navigation"
          onClick={onClose}
        >
          <X size={18} />
        </button>
      </div>

      <nav className="flex-1 px-4 space-y-2 mt-4">
        {menuItems.map((item) => (
          <button
            key={item.id}
            onClick={() => {
              setView(item.id as ViewState);
              onClose();
            }}
            className={`w-full flex items-center space-x-3 px-4 py-3 rounded-xl transition-all duration-200 ${
              currentView === item.id
                ? 'bg-sky-600/25 text-white border border-sky-500/35 border-l-4 border-l-sky-400 shadow-sm shadow-sky-700/10 [html.theme-light_&]:bg-sky-600/15 [html.theme-light_&]:border-sky-600/35 [html.theme-light_&]:border-l-sky-600 [html.theme-light_&]:text-sky-900'
                : 'text-slate-400 hover:bg-[#1e1e26] hover:text-white'
            }`}
          >
            <item.icon size={20} className={currentView === item.id ? 'text-sky-300 [html.theme-light_&]:text-sky-700' : 'text-sky-300/80 [html.theme-light_&]:text-sky-600'} />
            <span className="font-medium">{item.label}</span>
          </button>
        ))}
      </nav>

      <div className="p-4 border-t border-white/5 space-y-2">
        <button className="w-full flex items-center space-x-3 px-4 py-3 rounded-xl hover:bg-[#1e1e26] transition-colors text-slate-400 hover:text-white">
          <Settings size={20} />
          <span>Settings</span>
        </button>
        <button
          onClick={onLogout}
          className="w-full flex items-center space-x-3 px-4 py-3 rounded-xl hover:bg-[#1e1e26] transition-colors text-rose-400 hover:text-rose-300"
        >
          <LogOut size={20} />
          <span>Logout</span>
        </button>
      </div>
    </div>
  );
};

export default Sidebar;
